import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import api from "../../lib/api";
import { LumiMascot } from "../../components/Brand";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from "recharts";

export default function Progress() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/student/dashboard").then((r) => setData(r.data)); }, []);
  const conf = data?.confidence_by_subject || [];

  return (
    <AppShell isStudent>
      <h1 className="font-student font-bold text-3xl text-slate-900">{t("progress.title")}</h1>
      <p className="text-slate-600">{t("progress.subtitle")}</p>

      <div className="grid md:grid-cols-3 gap-4 mt-6">
        <div className="hb-card p-5">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("student.streak")}</div>
          <div className="font-student font-bold text-3xl mt-1">{data?.stats?.streak_days ?? 0} {t("student.days")}</div>
        </div>
        <div className="hb-card p-5">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("student.stars")}</div>
          <div className="font-student font-bold text-3xl mt-1">{data?.stats?.stars ?? 0}</div>
        </div>
        <div className="hb-card p-5">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("student.scans")}</div>
          <div className="font-student font-bold text-3xl mt-1">{data?.stats?.scans ?? 0}</div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-4">
        <div className="hb-card p-5">
          <div className="font-adult font-bold text-slate-900">{t("progress.confidenceBySubject")}</div>
          <div className="h-64 mt-2 chart-host">
            <ResponsiveContainer>
              <BarChart data={conf}>
                <XAxis dataKey="subject" tick={{ fontSize: 10 }} />
                <YAxis domain={[0, 5]} />
                <Tooltip />
                <Bar dataKey="confidence" fill="#3B82F6" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="hb-card p-5">
          <div className="font-adult font-bold text-slate-900">{t("progress.practiceBySubject")}</div>
          <div className="h-64 mt-2 chart-host">
            <ResponsiveContainer>
              <RadarChart data={conf}>
                <PolarGrid />
                <PolarAngleAxis dataKey="subject" tick={{ fontSize: 10 }} />
                <PolarRadiusAxis domain={[0, 6]} />
                <Radar name={t("student.sessions")} dataKey="sessions" stroke="#22C55E" fill="#22C55E" fillOpacity={0.3} />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="mt-6 hb-card p-5 flex items-center gap-3">
        <LumiMascot size={64} />
        <div className="text-slate-700 text-sm">{t("progress.cheer")}</div>
      </div>
    </AppShell>
  );
}
